import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import _ from "lodash";
import "./imagePortalStyle.css";

import { fetchAllSupplierImages, updateNavTitle } from "../../actions";

class ImagePortal extends React.Component {
  getImagesData() {
    if (!_.isEmpty(this.props.user)) {
      //check if image data already exists in memory
      const isDataCached = this.props.images.isCached;

      //if it hasn't retrieved data yet then do so from firestore
      if (!isDataCached) {
        console.log("[IMAGESPORTAL] >>> Getting ALL images from firestore!!!");
        this.props.user.supplierList.map(s => {
          const supplierId = s.split("_")[0];
          this.props.fetchAllSupplierImages(supplierId);
        });
      }
    }
  }

  componentDidMount() {
    console.log("[IMAGEPORTAL] COMPONENTDIDMOUNT");

    //set the title
    this.props.updateNavTitle("All images", false);

    //get images data
    this.getImagesData();
  }

  componentDidUpdate(prevProps) {
    console.log("[IMAGEPORTAL] COMPONENTDIDUPDATE");

    //get images data
    this.getImagesData();
  }

  render() {
    console.log(
      "[IMAGEPORTAL] RENDER",
      _.keys(this.props.images).length,
      this.props.images
    );
    if (
      _.isEmpty(this.props.images) ||
      _.keys(this.props.images).length === 3
    ) {
      return (
        <Grid
          container
          justify="center"
          alignItems="center"
          style={{ height: "calc(100vh - 64px)" }}
        >
          <Grid item>
            <CircularProgress />
          </Grid>
        </Grid>
      );
    } else {
      const { currentItem } = this.props.images;

      let imageItems = [];
      _.values(this.props.images).map(item => {
        if (_.isObject(item) && !_.isEmpty(item.name)) imageItems.push(item);
      });

      imageItems = _.chain(imageItems)
        .filter(item => {
          if (currentItem) {
            return (
              item.referenceNum === currentItem ||
              item.referenceNum === currentItem.concat(".")
            );
          } else {
            return true;
          }
        })
        .orderBy("createdAt", "desc")
        .value();

      const images = imageItems.map(item => {
        let imageName = item.name;
        return (
          <Grid item lg={3} sm={6} key={item.name}>
            <Link
              to={{ pathname: `/image/${item.name}` }}
              style={{ textDecoration: "none" }}
            >
              <Card className="image-card" elevation={0}>
                <div style={{ height: "79%", background: "#232323" }}>
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      background: "no-repeat",
                      overflow: "hidden",
                      backgroundImage: `url(${item.thumbnailUrl})`,
                      backgroundSize: "contain",
                      backgroundPosition: "center center"
                    }}
                  ></div>
                </div>
                <CardContent>
                  <div style={{ textOverflow: "ellipsis", overflow: "hidden" }}>
                    {imageName}
                  </div>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        );
      });
      return (
        <div style={{ padding: "40px" }}>
          <Grid container spacing={4}>
            {images}
          </Grid>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    images: state.imageList,
    auth: state.auth,
    user: state.user
  };
}

ImagePortal.propTypes = {
  images: PropTypes.object,
  auth: PropTypes.object,
  user: PropTypes.object,
  fetchAllSupplierImages: PropTypes.func,
  updateNavTitle: PropTypes.func
};

export default connect(mapStateToProps, {
  fetchAllSupplierImages,
  updateNavTitle
})(ImagePortal);
